import request from '@/utils/request'


// 查询食谱计划日期详情列表
export function listDayInfo(query) {
  return request({
    url: '/plan/dayInfo/list',
    method: 'get',
    params: query
  })
}

// 查询食谱计划日期详情分页
export function pageDayInfo(query) {
  return request({
    url: '/plan/dayInfo/page',
    method: 'get',
    params: query
  })
}

// 查询食谱计划日期详情详细
export function getDayInfo(data) {
  return request({
    url: '/plan/dayInfo/detail',
    method: 'get',
    params: data
  })
}

// 新增食谱计划日期详情
export function addDayInfo(data) {
  return request({
    url: '/plan/dayInfo/add',
    method: 'post',
    data: data
  })
}

// 修改食谱计划日期详情
export function updateDayInfo(data) {
  return request({
    url: '/plan/dayInfo/edit',
    method: 'post',
    data: data
  })
}

// 删除食谱计划日期详情
export function delDayInfo(data) {
  return request({
    url: '/plan/dayInfo/delete',
    method: 'post',
    data: data
  })
}
